<template>
  <base-button class="btn-primary" text="登録して利用する" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'UseAsMemberButton',
  components: {
    BaseButton,
  },
}
</script>
